//services/visionService.js
import axios from 'axios';

// API key should be securely stored in environment variables
const API_KEY = process.env.GOOGLE_API_KEY;
const VISION_API_URL = `https://vision.googleapis.com/v1/images:annotate?key=${API_KEY}`;
const USE_MOCK = false; // Set this to false for production use

// Extract text from Vision API response
const extractTextFromResponse = (responseData) => {
  if (!responseData || !responseData.responses || !responseData.responses[0]) {
    return null;
  }
  
  // Try document text detection first (better for structured text)
  if (responseData.responses[0].fullTextAnnotation) {
    return responseData.responses[0].fullTextAnnotation.text;
  }
  
  // Fall back to text annotations
  if (
    responseData.responses[0].textAnnotations && 
    responseData.responses[0].textAnnotations.length > 0
  ) {
    return responseData.responses[0].textAnnotations[0].description;
  }
  
  return null;
};

// Process image using Google Cloud Vision API for text detection
export const processImage = async (imageBase64) => {
  try {
    console.log('Starting image processing with Google Vision API...');
    
    // Clean up the base64 string if it has a data URL prefix
    const base64Content = imageBase64.replace(/^data:image\/(jpeg|png|jpg);base64,/, '');
    
    // Prepare request
    const requestData = {
      requests: [
        {
          features: [
            { type: 'TEXT_DETECTION', maxResults: 5 },
            { type: 'DOCUMENT_TEXT_DETECTION', maxResults: 5 }
          ],
          image: { content: base64Content }
        }
      ]
    };

    // Use mock data for testing if needed
    if (USE_MOCK) {
      console.log('Using mock data for testing');
      return "SAMPLE TEXT FOR TESTING\nSERIAL: ABC123456789\nPO: XYZ987654321\nMADE IN USA";
    } 
    
    // Only use the server proxy endpoint
    console.log('Sending request to server proxy');
    const response = await axios.post('/api/vision-proxy', requestData);
    
    if (response && response.data && response.data.text) {
      console.log('Text extracted successfully');
      return response.data.text;
    }
    
    throw new Error('No text detected in image');
  } catch (error) {
    console.error('Vision API error:', error);
    throw new Error('Failed to process image with Google Vision API: ' + error.message);
  }
};

// Process text with NLP server
export const processWithNLP = async (text, description) => {
  try {
    console.log("Starting NLP processing with description:", description);
    console.log("Text to process (first 100 chars):", text.substring(0, 100));
    
    const response = await fetch('/api/process-text', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        text: text,
        description: description
      })
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('NLP server error:', response.status, errorText);
      throw new Error(`NLP server returned error: ${response.status} ${errorText}`);
    }
    
    const data = await response.json();
    console.log("NLP response:", data);
    
    // Enhanced result handling
    if (data && data.result) {
      return data.result;
    } else if (data && data.error) {
      throw new Error(data.error);
    } else {
      return `No ${description} found`;
    }
  } catch (error) {
    console.error('NLP processing error:', error);
    return `Error processing text: ${error.message}`;
  }
};